import React, {useEffect, useRef, useState} from 'react';
// import trialFetch from './Hooks/TrialFetch';
import trialPost from './Hooks/TrialPost';
import trialSettings from './trialSettings';
import dataTableSettings from './dataTableSettings';
import DataTable from '../DataTable';
import styles from './styles';
import {NonTable} from '../NonTable';
import AddTrials from '../AddTrials';
import SearchTable from '../SearchTable';
// import csvDownload from './Hooks/CsvDownload';
import {selectSettings} from '../selectSettings';
import getCellActions from './getCellActions';
import getGroupActions from './getGroupActions';
import {InstanceContext} from '../../InstanceContext';
import {UserContext} from '../../Context/UserContext';
// import BulkUploads from '../BulkUploads';
import {TrialCache} from '../TrialCache';
import axios from 'axios';
import axiosConfig from '../../config/axios.config';
import {Toast} from '@xpertdox_js/xdcomponents';
import {colors} from '@xpertdox_js/xdstyle';
import { trackError } from '../../utils/activityTracker'
import MsgBanner from "../msgBanner";

const triageParamsMap = {
    'Inbox': 'inbox',
    'Study Team Contacted': 'piContacted',
    'Patient Contacted': 'patientContacted',
    'Final': 'final',
    'All': 'all',
    'Archived': 'archived'
}

const TrialUI = props => {
  const {cache, prioritizeCache, refreshCache} = React.useContext(TrialCache);
  const { user, userAction } = React.useContext(UserContext);
  const [customMemo, setCustomMemo] = useState(0)
  const [uiState, setUIState] = useState(null);
  const [broadcasting, setBroadcasting] = useState(false);
  const [notification, setNotification] = useState([]);
  const [processing, setProcessing] = useState(false)
  const params = props.match.params;
  const uiType = params.type;
  const tabSettings = trialSettings.tabs[uiType];
  const stateByType = uiState && uiState[uiType] ? uiState[uiType] : null;
  // const auth = useSelector(state => state.auth);
  const nonTableModules = ['addTrials','emailNewsletter', 'surveyQuestions', 'bulkUploads', 'userManagement', 'userActivity']
  const {contextInstance} = React.useContext(InstanceContext)
  const trialInstance = contextInstance || user.instance;
  const [modal, setModal] = useState(null);
  const openModal = data => setModal(data);
  let queryParam = props.location && props.location.search && props.location.search.includes('triage')
      ? props.location.search.split('?triage=')[1].replace(/%20/g, ' ')
      : false;
  const activeParam = React.useRef(queryParam ? queryParam : 'Inbox');
  // track mounted state
  // const mounted = useRef(false);
  // useEffect(() => {
  //     if(!mounted.current) mounted.current = true;
  //     return () => mounted.current = false;
  // }, []);
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
      if(!mounted) setMounted(true);
      return () => {
          activeParam.current = queryParam ? queryParam : 'Inbox';
          setMounted(false);
      };
  }, []);

  if(uiType === 'allTrials' && trialInstance === 'STANFORD') tabSettings.headers = tabSettings.headers.filter(i => !['priorityTrial'].includes(i))

  // initialize ui state
  const initialize = () => {
    let status = {};
    const initial = {
      data: null,
      error: false,
      refresh: false,
      message: '',
    }

    const instanceSettings = user.accountType === 'PI'
    ? trialSettings.instances['PI']
    : trialSettings.instances[params.instance] || trialSettings.instances.default;

    instanceSettings.tabs.forEach(tab => {
      status[tab] = {
        ...trialSettings.tabs[tab],
        ...initial
      }
    })
    status.postQue = [];
    status.queID = 0;
    status.updating = [];
    status.externalRefresh = null;
    status.lastMemo = trialInstance;
    setUIState(status);
  }

  // initial state & reset state on instance change
  const isNonTable = nonTableModules.includes(uiType);
  const searchTable = tabSettings.searchTable
  if (!isNonTable && !searchTable &&
      (uiState === null || uiState.lastMemo !== trialInstance)
  ) initialize()
  else if ((isNonTable || searchTable) && uiState !== null) setUIState(null);

  // state update
  const uiStateUpdate = (obj, trial=false) => {
    // console.log('OBJ => ',obj,'UI STATE =>', uiState, 'MOUNTED => ',mounted, 'Trial => ', trial, "TRIAL")
    if (mounted) {
      let stateChange = {...uiState};
      if (!trial) stateChange = {...stateChange, ...obj}
      else {
        stateChange[trial] = {...stateChange[trial], ...obj};
      }
      setUIState(stateChange);
    }
  }


  // add a post request to the que of post requests
  const addPostToQue = (postObj) => {
    let que = uiState.postQue.slice();
    que.push({...postObj, dt_post_que_id: 'post' + uiState.queID});
    const stateUpdate = {postQue: que, queID: uiState.queID + 1};
    if (postObj.update) {
      let updateList = [...uiState.updating,  'post' + uiState.queID];
      stateUpdate.updating = updateList;
    }
    // add post object to post que and update quiID for the next object
    uiStateUpdate(stateUpdate);
  }


  // check if trial type has initialized into state
  const typeHasInitialized = uiState && uiState[uiType];

  // Post Handler
  trialPost(
    uiState ? uiState.postQue.slice() : null,
    uiStateUpdate,
    {
      email: user.email,
      updateList: uiState ? uiState.updating : null,
      instance: trialInstance,
    }
   );

   // get fetch param key/id
   const getCacheParamID = (param=false) => {
     const valid = tabSettings.paramOptions
     && uiState && uiState[uiType] && uiState[uiType].userParam;

     if (!valid) return false;
     let optionID;
     const compareValue = param ? param.replace(/%20/g, ' ') : uiState[uiType].userParam.replace(/%20/g, ' ');
     Object.values(tabSettings.paramOptions).forEach((val, i) => {
       if (val === compareValue) optionID = Object.keys(tabSettings.paramOptions)[i];
     });
     return optionID;
   }
   const cacheParamID = getCacheParamID()


   // change fetch param based on top toolbar action
  const handleFetchParamChange = param => {
       // console.log(param, props, "param")
    // activeParam.current = param.replace(/%20/g, ' ');
    props.history.push(`${props.location.pathname}?triage=${param}`)
       // uiStateUpdate({userParam: param, refresh: true, data: null}, uiType);
    // prioritizeCache(uiType + '_po_' + getCacheParamID(param));
   };

  // set data after initialization;
  const cacheID = queryParam ? uiType+'_po_'+triageParamsMap[queryParam] : cacheParamID
  ? uiType + '_po_' + cacheParamID
  : tabSettings.paramOptions
  ? uiType + '_po_' + Object.keys(tabSettings.paramOptions)[0]
  : uiType;

  // let data = typeHasInitialized ? cache[cacheID].data : null;
  let data = typeHasInitialized ? cache[cacheID].data : null;
  // sorting allTrials based on priorityTrial
  if (uiType === 'allTrials' && data) {
    data.sort(function(a, b){return b.priorityTrial - a.priorityTrial});
  }

  let studyLocationArr = [];
  if (uiType === 'studyLocation' && data) {
    Object.keys(data).forEach(index => {
      let locationArr = [];
      let facilityArr = [];
      Object.keys(data[index].facilities).forEach(value => {
        let location =
          `${data[index].facilities[value].name}
          ${data[index].facilities[value].city && data[index].facilities[value].city !== 'undefined' ? ', '+data[index].facilities[value].city+',' : ''}
          ${data[index].facilities[value].state && data[index].facilities[value].state !== 'undefined' ? data[index].facilities[value].state+',' : ''}
          ${data[index].facilities[value].zip && data[index].facilities[value].zip !== 'undefined' ? data[index].facilities[value].zip+',' : ''}`
        let facility = data[index].facilities[value]
        locationArr.push(location)
        facilityArr.push(facility)
      })
      let studyLocationObj = {
        nct: data[index].nct,
        location: locationArr,
        facilities: facilityArr,
        email: user.email,
        instance: trialInstance,
      };
      studyLocationArr.push(studyLocationObj)
    })
  }
  // console.log('studyLocationArr', studyLocationArr)
  React.useEffect(() => {
    prioritizeCache(cacheID);
  }, [cacheID])


 // update refresh if needed
 if (uiState
   && uiState[uiType].refresh
   && cache[cacheID]
   && cache[cacheID].data
 ) uiStateUpdate({refresh: false}, uiType);

  // get headers from trial settings based on instance
  let headersFromTrialSettings = tabSettings.headers;

  // add custom actions to the data table settings for toolbars
  let menuSettings = {...dataTableSettings.menus};
  const settingsWithCustomActions = {
    ...dataTableSettings,
    menus: menuSettings
  }

  // get table cell dropdown component from settings(not required)
  const dropdownComponent = tabSettings.dropdown;
  const modalComponent = tabSettings.modal;
  // get table cell route from settings(not required)
  const path = document.location.pathname.split('/');
  const urlInstance = path[1] === 'trial_list' ? path[2] : path[1];
  const cellRoute = '/' + (urlInstance) + tabSettings.route;
  // get table cell route settings(not required)
  const cellRouteSettings = tabSettings.routeState;
  // refresh data in table
  const handleDataRefresh = (trialID=false, snapshot=false, params) => {
    // refresh trial cache
    if (tabSettings.paramOptions && params) {
        Object.keys(tabSettings.paramOptions).forEach(paramID => {
            if(tabSettings.paramOptions[paramID] === activeParam.current) refreshCache(uiType + '_po_' + paramID)
        })
    }
    else refreshCache(uiType);
    // udpate ui state for refresh
    const obj = {refresh: true};
    if (!snapshot) obj.data = null;
    uiStateUpdate(obj, trialID);
  }

  // table cell actions
  const cellActions = getCellActions({
    trialInstance: trialInstance,
    addPostToQue: addPostToQue,
    handleDataRefresh: handleDataRefresh,
    auth: user,
    setModal: openModal,
  })

  // group Actions
  settingsWithCustomActions.groupActions = getGroupActions({
    setBroadcasting: setBroadcasting,
    selectSettings: selectSettings,
    addPostToQue: addPostToQue,
    handleDataRefresh: handleDataRefresh,
    auth: user,
    instance: trialInstance
  });

  const processParsedData = (data= {}, nonModal) => {
    // console.log('processParsedData', data);
    setProcessing(true)
    // removed 'axiosConfig.auth' as token is updated on login
    axios.post(
      `${axiosConfig.apiUrl}/rt/console/bulkUpload/${user.email}`,
      {
        data,
        instance: contextInstance || user.instance,
        isBulkUpload: true
      }
    ).then(response => {
      // console.log(response, "RESPONSE")
      setProcessing(false)
      // setNotification([...notification, { title: 'Success', description: 'File successfully uploaded!', backgroundColor: colors.success }])
      if(!nonModal) {
        handleDataRefresh('studyContacts')
      }
    }).catch((err) =>{
      // TODO: Handle error
      setNotification([...notification, { title: 'Error', description: 'File upload failed!', backgroundColor: colors.error }])
      console.log(err)
      trackError({ error: err, history: props.history })
      if (err && err.response && err.response.status === 403) {
        userAction({type: 'logout'})
      }
    })
    if (!nonModal) clearNotification();
  }

  // custom component
  let customComponents = [{
    comp:(
      uiType === 'priorityTrials' || uiType === 'getTrials'
        ? AddTrials  : tabSettings.customToolbar ? tabSettings.customToolbar : null
    ),
    params: {isPi: uiType === 'getTrials'},
    settings: {
      passController: true,
    },
    props: (tabSettings.customToolbar || uiType === 'priorityTrials' || uiType === 'getTrials' || uiType === 'bulkUploads' || uiType === 'userActivity' || uiType === 'userManagement')
      ? {
        handleDataRefresh: () => handleDataRefresh(uiType),
        instance: contextInstance || user.instance
      }
      : null,
    location: 'top',
  }]

  // memo/key for rerenders on data changes
  const dtMemo = cacheID +
  (stateByType && stateByType.userParam
  ? stateByType.userParam : '') + customMemo;

  // custom memo for updates from children
  const customRefresh = () => {
    setCustomMemo(customMemo + 1);
  }

  // parameter that controls mutations on data fetch
  const fetchMutation = queryParam ? queryParam : stateByType
  ? stateByType.userParam || stateByType.fetchParam
  : null;


  const clearNotification = () => {
    setTimeout(() => setNotification([]), 2500)
  }

  const dataArr = uiType === 'studyLocation' ? studyLocationArr : data;
  // Render
  return(
    <React.Fragment>
      <MsgBanner type={uiType} user={user}/>
      <div
        id="trial-ui"
        style={{
          ...styles.container,
          // paddingTop: uiType === 'xpertTriage' ? '18px' : 0,
          paddingTop: 0,
        }}
      >
        <Toast autoDelete={false} autoDeleteTime={3000} toastList={notification} />
        {!nonTableModules.includes(uiType) && !searchTable

          ? <DataTable
              customComponents={customComponents}
              data={dataArr}
              memo={dtMemo}
              headers={headersFromTrialSettings || null}
              settings={settingsWithCustomActions}
              dropdown={dropdownComponent}
              modal={modalComponent}
              cellRoute={cellRoute}
              dataRefresh={handleDataRefresh}
              activeParam={activeParam}
              history={props.history}
              location={props.location}
              cellRouteSettings={cellRouteSettings}
              spreadActions={settingsWithCustomActions.groupActions[uiType]}
              routeSettings={{auth: user, instance: trialInstance}}
              cellActions={cellActions}
              tabSettings={tabSettings}
              fetchParamChange={handleFetchParamChange}
              activeFetchParam={fetchMutation}
              refreshing={stateByType ? stateByType.refresh : true}
              options={{
                downloadFilename: uiType === 'emailRecords' ? 'Broadcast_email_records.csv' : null,
                customTopOffset: '45px',
                offsetWidth: 175,
                customLeftOffset: parseInt(props.navSpacing),
              }}
            />
          : nonTableModules.includes(uiType) && !searchTable
          ? <NonTable
              type={uiType}
              {...props}
              auth={user}
              processParsedData={processParsedData}
              instance={trialInstance}
              refresh={customRefresh}
              processing={processing}
            />
          : <SearchTable
            {...props}
            dataTableSettings={dataTableSettings}
            tableSettings={tabSettings}
            trialStyles={styles}
            groupActions={settingsWithCustomActions.groupActions.searchPatients}
            broadcasting={broadcasting}
            setBroadcasting={setBroadcasting}
            instance={props.instance || trialInstance}
            auth={user}
          />
        }
      </div>

  </React.Fragment>
  )
}


export default TrialUI;
